import {createSlice} from "@reduxjs/toolkit";

const initialWebMenusState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  webMenuForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const webMenusSlice = createSlice({
  name: "webMenus",
  initialState: initialWebMenusState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getWebMenuById
    webMenuFetched: (state, action) => {
      state.actionsLoading = false;
      state.webMenuForEdit = action.payload.webMenuForEdit;
      state.error = null;
    },
    // findWebMenus
    webMenusFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createWebMenu
    webMenuCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.webMenu);
    },
    // updateWebMenu
    webMenuUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.webMenuId === action.payload.webMenu.webMenuId) {
          return action.payload.webMenu;
        }
        return entity;
      });
    },
    // deleteWebMenu
    webMenuDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.webMenuId !== action.payload.webMenuId);
    },
    // deleteWebMenus
    webMenusDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.webMenuId)
      );
    },
  }
});
